import { Delivery } from '@onepercentio/rarum-types/deliveries/model'
import { Address } from 'features/Form/AddressForm/AddressForm.types'
import {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { DeliveryPoint } from 'service/IDeliveryFacade'
import FakeDelivery from 'service/IDeliveryFacade/FakeDelivery'
import { QueriableContextShape, useQueriableContext } from './_QueriableContext'
import { getDeliveriesById } from 'core/modules/firebase/service/deliveries'
import { DeliveryType } from 'core/logic/delivery/delivery.types'

export const DELIVERY_STATUSES: DeliveryType['status'][] = [
  'AWAITING_LOGISTICS',
  'TRACKING',
]

const DeliveryContext = createContext<
  QueriableContextShape<DeliveryType> & {
    loadDeliveries: (ids: DeliveryType['id'][]) => Promise<void>
  }
>(null as any)

export default function DeliveryProvider({ children: c }: PropsWithChildren) {
  const [entities, setEntities] = useState<Delivery[]>()
  const loadEntities = useCallback((ids: Delivery['id'][]) => {
    return getDeliveriesById(ids).then((deliveries) => {
      setEntities((prev = []) => [...prev, ...deliveries])
    })
  }, [])
  return (
    <DeliveryContext.Provider
      value={{
        entities,
        id: 'delivery',
        loadDeliveries: loadEntities,
      }}>
      {c}
    </DeliveryContext.Provider>
  )
}

export function useDeliveryLocations(fromAddress: Address) {
  const instance = useMemo(() => new FakeDelivery(), [])
  const [deliveryLocations, setDeliveryLocations] = useState<DeliveryPoint[]>()

  useEffect(() => {
    instance.getAllDeliveryPoints(fromAddress.cep).then(setDeliveryLocations)
  }, [fromAddress])

  return {
    deliveryLocations,
  }
}

export function useDeliveries(deliveryIds?: NonNullable<Delivery['id']>[]) {
  const ctx = useContext(DeliveryContext)
  return useQueriableContext(ctx, deliveryIds, (e) => e.id!, ctx.loadDeliveries)
}
